<template>
  <div class="card card-client shadow mb-4">
    <div class="card-header">Usuarios de Control Panel</div>
    <div class="card-body" style="min-height: 200px">
      <my-spinner :loading="loading" />

      <div v-if="!special" class="alert text-danger p-2 mb-3">
        <strong><i class="fa fa-warning mr-1"></i> Atención</strong> <br />No
        tiene permiso para editar usuarios.
      </div>

      <div
        v-if="!loading && users.length == 0"
        class="text-center p-4 text-muted small"
      >
        No se encontraron usuarios
      </div>

      <div v-if="!loading" class="users-grid">
        <div
          v-for="(user, index) in users"
          :key="'user_' + index"
          class="user-card"
        >
          <p class="font-weight-600 mb-1">
            {{ user.firstName }} {{ user.lastName }}
          </p>
          <p
            class="font-weight-normal text-muted small mb-1 truncate-text"
            :title="user.emailAddress"
          >
            {{ user.emailAddress || "--" }}
          </p>

          <div style="position:relative: min-height: 100px;">
            <span
              class="text-center text-muted"
              v-if="user.status === 'loading'"
              >Cargando status...</span
            >

            <template v-else>
              <span v-if="!user.status" class="badge badge-secondary"
                >Desconocido</span
              >

              <span
                v-else
                class="badge"
                :class="
                  compareStrings(user.status, 'active')
                    ? 'badge-success'
                    : 'badge-danger'
                "
              >
                {{
                  compareStrings(user.status, "active") ? "Activo" : "Bloqueado"
                }}</span
              >
            </template>
          </div>

          <div class="text-center p-3 my-1">
            <button
              :disabled="!user.status || user.status === 'loading' || !special"
              type="button"
              @click="handleAction(user)"
              class="btn btn-white"
            >
              {{
                compareStrings(user.status, "active")
                  ? "Bloquear"
                  : "Desbloquear"
              }}
            </button>
          </div>

          <div class="mt-2 text-small text-muted text-center">
            {{ user.position }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/helpers/utils";
import sysMsgs from "@/helpers/system.message";
import ssoServices from "@/services/sso.services";
import profileServices from "@/services/memberprofile.services";
import entityServices from "@/services/entity.services.js";
import userManagementServices from "@/services/userManagement.services.js";
import clientesServices from "@/services/dealers.services";
import Auth from "@/helpers/middleware";
export default {
  name: "DealerUsers",
  props: ["dealer", "actions", "special", "loadingStatus"],
  data() {
    return {
      users: [],
      loading: false,
    };
  },
  created() {
    this.getUsers();
  },
  computed: {
    hasActiveUsers() {
      return (
        this.users.filter((user) => utils.compareStrings(user.status, "active"))
          .length > 0
      );
    },
    updateLocalDealer() {
      const _users = [
        ...this.users.filter((f) => utils.compareStrings(f.status, "inactive")),
      ];
      return _users.length === this.users.length;
    },
  },
  watch: {
    dealer: {
      deep: true,
      handler(data) {
        this.users = [];
        if (data) {
          this.getUsers();
        }
      },
    },
    users: {
      deep: true,
      handler(data) {
        if (data) {
          this.$emit(
            "update:isActive",
            this.users.filter((user) =>
              utils.compareStrings(user.status, "active")
            ).length > 0
          );
        } else {
          this.$emit("update:isActive", false);
        }
      },
    },
  },
  methods: {
    getUserStatus(user) {
      this.loading = true;
      this.$emit("update:loadingStatus", true);
      return profileServices
        .getMemberStatus(user.membershipId)
        .then((data) => {
          this.loading = false;
          this.$emit("update:loadingStatus", false);
          return data;
        })
        .catch((error) => {
          console.log("Component: DealerUsers, FN: getUserStatus", error);
          if (error.response.status == 404)
            sysMsgs.getMessage("Status no encontrado", "info");
          else {
            sysMsgs.getResponseMessage(error.response);
          }

          this.$emit("update:loadingStatus", false);
          this.loading = false;
          return null;
        });
    },
    renderUserStatus(users) {
      [...users].forEach(async (user) => {
        let newUser = await this.getUserStatus(user);
        if (newUser) {
          this.users = [...this.users, { ...user, ...newUser }];
        }
      });
    },
    getUsers() {
      this.users = [];
      this.loading = true;
      this.$emit("update:loadingStatus", true);
      userManagementServices
        .getUsers(this.dealer.identifier)
        .then((data) => {
          this.renderUserStatus(data.data && data.data.length ? data.data : []);
          this.loading = false;
          this.$emit("update:loadingStatus", false);
        })
        .catch((error) => {
          console.log("Component: DealerUsers, FN: getUsers", error.message);
          this.loading = false;
          this.$emit("update:loadingStatus", false);
          sysMsgs.getResponseMessage(error.response);
        });
    },
    handleAction(user) {
      sysMsgs
        .getConfirm(
          `Se cambiará el estatus del usuario a: ${
            utils.compareStrings(user.status, "active") ? "Bloqueado" : "Activo"
          }`,
          "warning",
          "Confirmar acción"
        )
        .then((result) => {
          if (result.value) {
            this.toggleStatus(user);
          }
        });
    },
    toggleStatus(user) {
      this.hasError = false;
      this.loading = true;
      const newStatus = utils.compareStrings(user.status, "active")
        ? "Inactive"
        : "Active";
      ssoServices
        .updateMemberStatusV2(user.membershipId, newStatus)
        .then(() => {
          user.status = newStatus;
          this.setDealerLocalStatus();
          if (newStatus == "Inactive") {
            ssoServices
              .removeMemberCookie(user.membershipId)
              .then((data) => {
                console.log("ssoServices.removeMemberCookie::OK");
              })
              .catch((error) => {
                console.log("ssoServices.removeMemberCookie::ERROR", error);
              });
          }
          //this.toggleStatusCpServices(newStatus, this.dealer.identifier);
        })
        .catch((error) => {
          this.hasError = true;
          this.loading = false;
          console.log(
            "Component: DealerUsers, FN: toggleStatus",
            error.message
          );
          sysMsgs.getMessage(
            "Error al actualizar estatus del usuario: " + user.firstName,
            "error"
          );
          console.log(error);
        });
    },
    compareStrings(a, b) {
      return utils.compareStrings(a, b);
    },
    setDealerLocalStatus() {
      clientesServices.general
        .dealerStatus({
          cod_cliente: this.dealer.id,
          cliente: this.updateLocalDealer,
          publicaciones: false,
          usuario: Auth.getUser() ? Auth.getUser().email : "",
        })
        .then((response) => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleStatusCpServices(status, identifier) {
      this.hasError = false;
      this.loading = true;

      if (utils.compareStrings(status, "active")) {
        this.CPActiveService(identifier);
      } else {
        this.CPRemoveService(identifier);
      }
    },
    CPActiveService(identifier) {
      ssoServices
        .CP_ActiveService(identifier)
        .then(() => {})
        .catch((error) => {
          this.hasError = true;
          this.loading = false;
          console.log(
            "Component: DealerUsers, FN: CPActiveService",
            error.message
          );
          sysMsgs.getMessage(
            "[CP]Error al actualizar estatus del usuario",
            "error"
          );
          console.log(error);
        });
    },
    CPRemoveService(identifier) {
      ssoServices
        .CP_RemoveService(identifier)
        .then(() => {})
        .catch((error) => {
          this.hasError = true;
          this.loading = false;
          console.log(
            "Component: DealerUsers, FN: CPRemoveService",
            error.message
          );
          sysMsgs.getMessage(
            "[CP-remove]Error al actualizar estatus del usuario",
            "error"
          );
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 15px;
}

.user-card {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 3px;
  text-align: center;
}

.truncate-text {
  display: block;
  overflow: hidden;
  width: 90%;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>